import React from 'react';

import { IntakeManagementPageInitialProps } from '~/data';
import {
  QueryParameterContextProvider,
  SearchResultContextProvider,
  SelectedIntakesContextProvider,
  SessionContextProvider,
  StaticPropsContextProvider,
} from '~/context';

interface SearchContextProvider {
  children: React.ReactNode;
  initialProps: IntakeManagementPageInitialProps; // to-do: update to correct type
}
export function IntakeManagementProvider(props: SearchContextProvider) {
  return (
    <SessionContextProvider>
      <StaticPropsContextProvider initialProps={props.initialProps}>
        <QueryParameterContextProvider>
          <SelectedIntakesContextProvider>
            <SearchResultContextProvider>{props.children}</SearchResultContextProvider>
          </SelectedIntakesContextProvider>
        </QueryParameterContextProvider>
      </StaticPropsContextProvider>
    </SessionContextProvider>
  );
}
